import { Swiper, SwiperSlide } from 'vue-awesome-swiper';
import { ABtn } from '@maisaedu/ui-components-a-btn';
import { AInput } from '@maisaedu/ui-components-a-input';
import { ATooltip } from '@maisaedu/ui-components-a-tooltip';
import { mapGetters, mapState, mapMutations, mapActions } from 'vuex';
import 'swiper/swiper.scss';

import courseMixins from '@/mixins/templates/course';
import ContentSyncMixin from '@/mixins/content-sync';

import Carousel from './carousel';
import SelectContentType from '@/components/content-v2/select-content-type';
import ContentNotAvailable from '@/components/content-v2/content-not-available';
import PageHeader from '@/components/content-v2/templates/common/page-header';
import CardTopic from '@/components/content-v2/templates/streaming/card-topic';
import ContentMigration from '@/components/content-v2/modals/content-migration';
import CardTopicModal from '@/components/content-v2/templates/streaming/card-topic-modal';
import TopicSettingsMenu from '@/components/content-v2/templates/common/topic-settings-menu';
import contentMigrationInformation from '@/components/content-v2/modals/content-migration-information';
import NoticeCarousel from '@/components/comunication/notice-carousel';
import RejectApprovalModal from '@/components/content-v2/modals/reject-approval-modal';
import MaxModuleLimit from '@/components/content-v2/templates/common/max-module-limit';
import PendingApprovalBanner from '@/components/content-v2/templates/common/pending-approval-banner';
import SyncSummaryListDetail from '@/components/content-v2/modals/content-sync/sync-summary-list-detail';
import EmptyAssociatedWarning from '@/components/ui/empty-associated-warn';
import SyncStatus from '@/components/content-v2/modals/content-sync/sync-status';
import FloatingSupport from '~/components/_core/ui/floating-support/index.vue';

import CategoryType from '@/helpers/contentCategory';
import contentType from '@/helpers/contentType';
import { hasPermission, hasPermissions } from '@/helpers/permission';

export default {
  mixins     : [courseMixins, ContentSyncMixin],
  components : {
    PageHeader,
    CardTopic,
    Swiper,
    SwiperSlide,
    Carousel,
    CardTopicModal,
    TopicSettingsMenu,
    SelectContentType,
    ContentNotAvailable,
    ContentMigration,
    contentMigrationInformation,
    AInput,
    ABtn,
    ATooltip,
    NoticeCarousel,
    RejectApprovalModal,
    MaxModuleLimit,
    PendingApprovalBanner,
    SyncSummaryListDetail,
    EmptyAssociatedWarning,
    SyncStatus,
    FloatingSupport
  },
  computed: {
    ...mapGetters({
      getterUserRoleContext : 'plataforma/user/getterUserContext',
      getterCourse          : 'plataforma/newContent/getterCourse',
      getUserId             : '_core/user/getUserId'
    }),
    ...mapState({
      user: (state) => state._core.user
    }),
    summaryTitle() {
      return this.isMasterCourse && !this.getterUserRoleContext.isStudent
        ? this.$t('content.layout.timeline.course.masterCourseSummary')
        : this.getSummaryText();
    },
    isSyncStatusEnabled() {
      return this.getterUserRoleContext.isPublisher && (this.isAssociatedCourse || (this.isMasterCourse && this.getterCourse?.associatedAcademicMains?.length && this.getterCourse?.topics?.length));
    }
  },
  mounted() {
    this.validateOpenContentMigrationInformationDialog();
    this.verifyPermissions();
  },
  data() {
    return {
      contentType,
      hasContentConfigurePermission : false,
      hasFolderConfigurePermission  : false,
      cardTopicDialogOptions        : {
        isOpen      : false,
        parentTopic : null,
        topic       : null
      },
      contentMigration: {
        isOpen : false,
        topic  : null
      },
      addContentOptions: [
        { text: 'content.elementOptions.newModuleGroup', icon: 'mdi-folder-plus-outline' },
        { text: 'content.elementOptions.newModule', icon: 'mdi-post-outline' },
        { text: 'content.elementOptions.newContentOrActivity', icon: 'mdi-toy-brick-plus-outline' }
      ],
      isOpenContentMigrationInformationDialog : false,
      grouperTooltipToBeDisplayed             : null,
      hasHighlightNotices                     : false
    };
  },
  methods: {
    ...mapActions({
      actionPatchTitleTopic : 'plataforma/newContent/actionPatchTitleTopic',
      actionSaveNewTopic    : 'plataforma/newContent/actionSaveNewTopic'
    }),
    ...mapMutations({
      SET_IS_EDITING_TOPIC : 'plataforma/newContent/SET_IS_EDITING_TOPIC',
      NEW_TOPIC            : 'plataforma/newContent/NEW_TOPIC',
      SET_IS_EDITING_TOPIC : 'plataforma/newContent/SET_IS_EDITING_TOPIC'
    }),
    verifyPermissions() {
      const configurePermissionAliasList = contentType.getPermissions('configure', { includeMarketplace: false });
      this.hasContentConfigurePermission = hasPermissions(
        this.getterCourse.context.academicMainId,
        this.getterCourse.context.academicMainTypeId,
        null,
        null,
        configurePermissionAliasList,
        this.getterCourse.permissions
      );
      this.hasFolderConfigurePermission = hasPermission(
        this.getterCourse.context.academicMainId,
        this.getterCourse.context.academicMainTypeId,
        null,
        contentType.FOLDER,
        'configure',
        this.getterCourse.permissions
      );
    },
    validateOpenContentMigrationInformationDialog() {
      const hasFakeModule = this.getterCourse.topics.some(topic => this.checkIsFakeModule(topic));
      const hasdataOnLocalStorage = !!localStorage.getItem('contentMigration');
      const hasIdOnLocalStorage = hasdataOnLocalStorage && !!JSON.parse(localStorage.getItem('contentMigration'))[this.getUserId];

      if (this.getterUserRoleContext.isPublisher && hasFakeModule && (!hasdataOnLocalStorage || !hasIdOnLocalStorage || !JSON.parse(localStorage.getItem('contentMigration'))[this.getUserId].includes(this.$route.params.courseId))) {
        this.isOpenContentMigrationInformationDialog = true;
      }
    },
    checkIsFakeModule(topic) {
      return topic.id === (topic.children && topic.children[0] && topic.children[0].id);
    },
    openMigrationModal(topic) {
      this.contentMigration.isOpen = true;
      this.contentMigration.topic = topic;
    },
    handleCardTopicClick(topic, children) {
      if (window.innerWidth <= 960 && !this.cardTopicDialogOptions.isOpen) {
        this.handleCardTopicDialogOptions(topic, children);

        return;
      }

      if (topic.isBlockedContentByConditional) {
        this.$nuxt.$emit('changeIsOpenConditionalsListModal', {
          conditionals        : topic.conditionals,
          isAccessCodeEnabled : topic.isAccessCodeEnabled
        });
      } else if (children.isBlockedContentByConditional) {
        this.$nuxt.$emit('changeIsOpenConditionalsListModal', {
          conditionals        : children.conditionals,
          isAccessCodeEnabled : children.isAccessCodeEnabled
        });
      } else {
        this.openTopic(children);
      }
    },
    handleCardTopicDialogOptions(topic, children) {
      this.cardTopicDialogOptions = {
        isOpen      : true,
        parentTopic : topic,
        topic       : children
      };
    },
    closeDialogOptions() {
      this.cardTopicDialogOptions = {
        isOpen      : false,
        parentTopic : null,
        topic       : null
      };
    },
    closeContentMigrationModal() {
      this.contentMigration.isOpen = false;
    },
    changeIsEditingTopic(index, isToFocus = false) {
      this.SET_IS_EDITING_TOPIC(index);

      if (isToFocus) {
        this.$nextTick(() => {
          this.$refs[`topicTitleInput${index}`]?.[0]?.focus();
        });
      }
    },
    changeTopicTitle(topic) {
      const params = {
        topicId        : topic.id,
        academicMainId : this.$route.params.courseId,
        title          : topic.title,
        version        : this.getterCourse.context.version
      };

      this.$nuxt.$loading.start();

      this.actionPatchTitleTopic(params)
        .then(() => {
          this.$toast.success(this.$t('content.successMessagesSnackbar.changeTitle'));
        }).catch((err) => {
          this.$toast.error(err.data.error.message);
        }).finally(() => {
          this.$nuxt.$loading.finish();
        });
    },
    openEvaluationsCenter() {
      this.$nuxt.$emit('changeIsOpenModalEvaluations', {
        showModal              : true,
        contentId              : this.getterCourse.context.contentId,
        academicMainId         : this.getterCourse.context.academicMainId,
        academicMainExternalId : this.getterCourse.context.academicMainExternalId,
        academicMainTypeId     : this.getterCourse.context.academicMainTypeId
      });
    },
    openParticipants() {
      this.$refs.pageHeader.participantManagementModalConfig = {
        isOpen                 : true,
        courseId               : this.getterCourse.context.academicMainId,
        academicMainId         : this.getterCourse.context.academicMainId,
        academicMainName       : this.getterCourse.context.academicMainName,
        academicMainTypeId     : this.getterCourse.context.academicMainTypeId,
        academicMainExternalId : this.getterCourse.context.academicMainExternalId
      };
    },
    createModuleGroup(index) {
      if (this.maxModuleAchievedValidation) {
        this.maxModuleAchievedModal();

        return;
      }
      this.$nuxt.$loading.start();

      const params = {
        topic: {
          title                              : this.$t('content.layout.streaming.course.defaultModuleGroupTitle'),
          sequence                           : index + 1,
          categoryTypeId                     : CategoryType.ORGANIZATION,
          topicTypeId                        : contentType.FOLDER,
          parentTopicId                      : null,
          hasConditional                     : false,
          isVisibleIsControlledByConditional : false,
          conditionals                       : [],
          design                             : {},
          version                            : this.getterCourse.context.version
        },
        academicMainId      : this.$route.params.courseId,
        isToReplacePosition : true,
        index               : index
      };

      this.actionSaveNewTopic(params)
        .then(data => {
          this.$toast.success(this.$t('content.successMessagesSnackbar.createGroupModule'));
          this.focusNewGroup(data.id);
          this.SET_IS_EDITING_TOPIC(index);
        }).catch((err) => {
          this.$toast.error(err.message);
        }).finally(() => {
          this.$nuxt.$loading.finish();
        });
    },
    focusNewGroup(topicId) {
      this.$nextTick(() => {
        const newElement = document.getElementById(topicId);
        newElement.scrollIntoView({ behavior: 'smooth' });
      });
    },
    openSyncModal() {
      this.$nuxt.$emit('changeIsOpenModalContentSync', { academicMainId: this.getterCourse.context.academicMainId });
    },
    handleOpenSyncContentsCount() {
      this.isSyncSummaryListDetailOpen = true;
    },
    openImportModal() {
      this.$nuxt.$emit('changeIsOpenModalContentImport', { academicMainIdDestination: this.getterCourse.context.academicMainId, academicMainDestinationName: this.getterCourse.context.academicMainName });
    }
  }
};
